/*!

=========================================================
* BLK Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

class PageHeader extends React.Component {
  render() {
    return (
      <div className="page-header header-filter">
        <div className="squares square1" />
        <div className="squares square2" />
        <div className="squares square3" />
        <div className="squares square4" />
        <div className="squares square5" />
        <div className="squares square6" />
        <div className="squares square7" />
        <Container>
          <div className="content-center brand">
            <h1 className="h1-seo">Demo</h1>
            <h3 className="d-none d-sm-block">
              Profit Shares Calculator based on Tasks Done by Partners
            </h3>
            <h5 className="d-none d-sm-block">
              Design for small businesses
            </h5>
            <h6 className="d-none d-sm-block">
              register as new user or login as admin to test out full functionality.

            </h6>

            <h5>
            admin username: yijungan
            </h5>
            <h5>
            admin password: admin0829</h5>


          </div>
        </Container>
      </div>
    );
  }
}

export default PageHeader;
